import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { TravelExploreRounded } from '@mui/icons-material';

type ActionResponse = { id: string }[];
type ActionArgs = { query?: string; netCode?: string };

export type AndieSearchProfilesProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieSearchProfiles = (props: AndieSearchProfilesProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.search-profiles.title')}
            icon={<TravelExploreRounded fontSize="small" />}
            network={props.args?.netCode}
            loadingMessages={(args) => [
                t('andie.tool.search-profiles.loading', { value: args?.query ?? '' }),
            ]}
            completeMessage={({ result }) =>
                t('andie.tool.search-profiles.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieSearchProfiles;
